export default {"src":"/_next/static/media/phone_call_icon.e8720c8b.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};